import { render, staticRenderFns } from "./receiptsAndReceipts.vue?vue&type=template&id=fc273838&scoped=true&"
import script from "./receiptsAndReceipts.vue?vue&type=script&lang=js&"
export * from "./receiptsAndReceipts.vue?vue&type=script&lang=js&"
import style0 from "./receiptsAndReceipts.vue?vue&type=style&index=0&id=fc273838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc273838",
  null
  
)

export default component.exports